import { withTranslation } from 'react-i18next'
import { List, ListItem, ListItemText, Grid } from '@material-ui/core'

function HistoricItems({
  classes,
  archives,
  setHistorySelected,
  t
}) {
  return(
    <List className={classes.List__root}>
      {archives.map(archive =>
        <Grid item sm={12} xs={12} key={archive.id}>
          <ListItem 
            alignItems='flex-start' 
            onClick={() => setHistorySelected(archive)}
            className={classes.List__root_item}
          >
            <ListItemText
              primary={archive.name.toUpperCase()}
              secondary={archive.historyText}
              primaryTypographyProps={{ color: 'primary' }}
            />
          </ListItem>
        </Grid>
      )}
    </List>
  )
}

export default withTranslation()(HistoricItems)